<template>
  <component
    :is="url ? 'a' : 'button'"
    class="card-template"
    :style="
      imagePath
        ? {
            backgroundImage: `
        var(--gradient-black),
        url(${$baseUrl}images/${imagePath}.webp)
        `,
          }
        : {}
    "
    :disabled="!cta"
    :href="url || null"
    :target="url ? '_blank' : null"
    @mouseenter="toggeHovered"
    @mouseleave="toggeHovered"
    @click="onClick"
  >
    <div
      :class="['card-template__content', { 'with-cta': cta && !smallscreen }]"
    >
      <slot></slot>
    </div>

    <CtaBar v-if="cta" :cta="cta" :hovered="hovered" />
  </component>
</template>

<script setup>
import { inject, ref, computed } from "vue";
import useTvaMq from "@/plugins/tvaMq.js";
import { pushData } from "@/utilities/analytics-functions.js";

import CtaBar from "./CtaBar.vue";

const props = defineProps({
  imagePath: {
    type: String,
  },
  cta: String,
  url: String,
});

const emit = defineEmits(["onClick"]);

const $baseUrl = inject("$baseUrl");
const { $tvaMq } = useTvaMq();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));

const hovered = ref(false);

function toggeHovered() {
  if (props.cta) {
    hovered.value = !hovered.value;
  }
}

function onClick() {
  if (props.url) {
    if (props.url.includes(".pdf")) {
      pushData("pdf", props.url, "", props.cta);
    }
  } else {
    emit("onClick");
  }
}
</script>

<style lang="scss" scoped>
.card-template {
  width: 100%;
  max-width: var(--max-card-width);
  background-position: 50%;
  aspect-ratio: 0.82;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  background-size: cover;
  text-align: left;
  position: relative;

  &__content {
    padding: 1.5rem;
    transition: transform 0.5s;

    &.with-cta {
      transform: translateY(var(--cta-bar-height));
    }
  }

  &:hover {
    .with-cta.card-template__content {
      transform: translateY(0);
    }
  }
}
</style>
